import "./WallCreate.scss";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { createPostApi } from "../../../../api/wall";
import WallForm from "../../../../components/Wall/WallForm";
import { connect } from "react-redux";
import { store } from "../../../../store/configureStore";
import * as accountActions from "../../../../store/actions/accountActions";
import { sendAccount } from "../../../../api/account";

function WallCreate(props) {
  const [loadCreate, setLoadCreate] = useState(false);
  // const [optinsLink] = useState({
  //   gdpr: props.config.register.opt_ins.ppFilePath
  //     ? props.config.register.opt_ins.ppFilePath
  //     : null,
  //   tou: props.config.register.opt_ins.touFilePath
  //     ? props.config.register.opt_ins.touFilePath
  //     : null,
  // });
  let filesPreview = [];

  const updatePreviews = (dataFilesPreview) => {
    filesPreview = dataFilesPreview;
  };

  /**
   * Creation du poste
   */
  const createPost = (brand, files, productName, legend, theme) => {
    console.log('files', files)
    console.log('files', filesPreview)
    if (loadCreate) {
      return;
    }

    let formData = new FormData();
    setLoadCreate(true);
    formData.append("brand", brand);
    formData.append("product", productName);

    if (undefined !== legend) {
      formData.append("content", legend);
    }
    formData.append("theme", theme);
    for (let i = 0; i < files.length; i++) {
      formData.append("files[" + i + "]", files[i]);
    }
    for (let i = 0; i < filesPreview.length; i++) {
      // TODO GERER SI INDEX VIDE
      formData.append("thumbnails[" + i + "]", filesPreview[i]);
    }

    createPostApi(formData)
      .then(() => {
        props.history.replace("/wall");
      })
      .catch(console.log)
      .finally(() => {
        setLoadCreate(false);
      });

    if (!account.optin_wall) {
      let accountData = account;
      accountData.optin_wall = true;
      sendAccount(accountData)
        .then(() => {
          store.dispatch(accountActions.setAccountDatas(accountData));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const { account, history, location, t } = props;

  return (
    <div className="bg_white wall_create">
      <WallForm
        loadCreate={loadCreate}
        submitPost={createPost}
        history={history}
        location={location}
        filesPreview={updatePreviews}
        optin_wall={account.optin_wall}
        optins_link={{
          gdpr: props.config.register.opt_ins.ppFilePath
            ? props.config.register.opt_ins.ppFilePath
            : null,
          tou: props.config.register.opt_ins.touFilePath
            ? props.config.register.opt_ins.touFilePath
            : null,
        }}
        t={t}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(WallCreate));
